<template>
  <div class="modal" v-bind:class="{'modal--mobile': isMobileLandscape()}" v-if="which">
    <div class="modal__overlay" @click="$emit('closeModal')"></div>

    <div class="modal__comic-nav" v-if="which === 'comics'">
      <button class="modal__comic-first" title="First comic"
        @click="load(0)" :disabled="show === 0"></button>
      <button class="modal__comic-prev" title="Previous comic"
        @click="load(show - 1)" :disabled="show === 0"></button>
      <button class="modal__comic-close" title="Reutrn to home"
        @click="$emit('closeModal')"></button>
      <button class="modal__comic-next" title="Next comic"
        @click="load(show + 1)" :disabled="show === comics.length - 1"></button>
      <button class="modal__comic-last" title="Latest comic"
        @click="load(comics.length - 1)" :disabled="show === comics.length - 1"></button>
    </div>
    <div class="modal__comic" v-if="which === 'comics'">
      <div class="modal__comic-content">
        <img class="modal__comic-image" />
        <div class="modal__comic-title">{{ (show > -1) ? comics[show].title : 'ERROR' }}</div>
        <div class="modal__comic-date">{{ (show > -1) ? displayTime(show) : 'ERROR' }}</div>
        <div class="modal__comic-post" v-html="(show > -1) ? comics[show].newspost : 'ERROR'"></div>
      </div>
    </div>

    <div class="modal__slides-arrow" v-if="slideArrows()">
      <button class="modal__slides-arrow-prev" title="Previous page"
        @click="loadSlide(show - 1)" :disabled="show === 0"></button>
      <button class="modal__slides-arrow-next" title="Next page"
        @click="loadSlide(show + 1)" :disabled="show === slides.length - 1"></button>
    </div>
    <div class="modal__slides" v-if="which !== 'comics'">
      <button class="modal__slides-prev" title="Previous page"
        @click="loadSlide(show - 1)" :disabled="show === 0"></button>
      <button class="modal__slides-next" title="Next page"
        @click="loadSlide(show + 1)" :disabled="show === slides.length - 1"></button>
      <img class="modal__slides-image" />
      <button class="modal__slides-close" @click="$emit('closeModal')">&cross;</button>
    </div>
    <div class="modal__slides-contact-info" v-if="which === 'contact_info'">
      <a class="modal__slides-contact-info-email" href="mailto:stiles.billy@gmail.com"
        aria-label="Email William Stiles"></a>
      <a class="modal__slides-contact-info-phone" href="tel:14015336729"
        aria-label="Call William Stiles"></a>
    </div>
    <div class="modal__slides-animation-reel" v-if="which === 'animation_reel'">
      <div class="modal__slides-animation-reel-video">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/Dp-j1I2MjPs?rel=0&amp;showinfo=0" @load="resizeBody()" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import H from '@/helpers/H';

export default {
  name: 'Modal',
  props: ['which', 'comics', 'popups'],
  watch: {
    which(newVal) { // Set initial value.
      if (newVal === 'comics') setTimeout(() => this.load(this.comics.length - 1), 0);
      else if (newVal) setTimeout(() => this.loadSlide(0), 250);
      else if (this.slides.length) {
        this.slides = [];
        this.show = -1;
      }
      if (newVal) setTimeout(() => this.resizeBody(), 250);
    },
  },
  data() {
    return {
      show: -1,
      slides: [],
    };
  },
  methods: {
    displayTime(i) { return H.showTime(this.comics[i].date); },
    load(i) {
      const url = H.comic(this.comics[i]);
      this.$el.querySelector('.modal__comic-image').src = url;
      if (url.indexOf('/error.jpg') === -1) this.show = i;
      else this.show = -1;
      return url;
    },
    loadSlide(i) {
      if (!this.slides.length) this.slides = H.popup(this.popups, this.which);
      this.$el.querySelector('.modal__slides-image').src = this.slides[i];
      if (this.slides[i] && this.slides[i].indexOf('/error.jpg') === -1) this.show = i;
      else this.show = -1;
      return this.slides[i];
    },
    slideArrows() { return this.which === 'gallery_frames'; },
    isMobileLandscape() {
      if (!document.querySelector('.modal__slides-animation-reel')) return false;
      return window.innerHeight < 769 && window.innerHeight < window.innerWidth;
    },
    resizeBody() {
      const overlay = document.querySelector('.modal__slides-contact-info')
        || document.querySelector('.modal__slides-animation-reel');

      if (overlay) {
        if (/reel/.test(overlay.className)) {
          if (this.isMobileLandscape()) this.loadSlide(1);
          else this.loadSlide(0);
        }

        setTimeout(() => {
          const img = document.querySelector('.modal__slides-image');
          if (img.offsetWidth !== img.naturalWidth) {
            overlay.style.transform = `translate(-50%, -50%) scale(${img.offsetWidth / img.naturalWidth})`;
          } else {
            overlay.style.transform = 'translate(-50%, -50%)';
          }

          if (/reel/.test(overlay.className) && this.isMobileLandscape()) {
            const nudge = window.innerHeight - img.offsetHeight;
            document.querySelector('.modal__slides').style.transform = `translate(-50%, ${nudge}px)`;
            overlay.style.marginTop = `${(nudge / 2) + 2}px`;
          } else {
            document.querySelector('.modal__slides').style.transform = '';
            overlay.style.marginTop = '';
          }
        }, 0);
      }
    },
  },
  mounted() { window.addEventListener('resize', this.resizeBody); },
  beforeDestroy() { window.removeEventListener('resize', this.resizeBody); },
};
</script>

<style lang="scss" scoped>
@import '../tools.mixins';

.modal{
  &__overlay{
    @include abs(0, 0, 100%, 100%);
    background: rgba(0, 0, 0, 0.5);
    z-index: 7;
  }

  &__comic{
    @include abs(15px, 50%, auto, auto);
    max-height: calc(100% - 30px);
    max-width: calc(100% - 10px);
    transform: translate(-50%, 0);
    border-radius: 5px;
    background: #96B2D0;
    overflow: auto;
    z-index: 8;

    &-nav{
      @include fix(10px, 50%, auto, auto);
      transform: translate(-50%, 0);
      white-space: nowrap;
      z-index: 9;
      @media (max-width: 390px) { transform: translate(-50%, 0) scale(0.8); }
    }

    &-first{ @include comicNavB('first', 98px); }
    &-prev{ @include comicNavB('prev', 56px); }
    &-next{ @include comicNavB('next', 56px); }
    &-last{ @include comicNavB('last', 98px); }
    &-close{
      @include comicNavB('close', 33px);
      margin: 0 13px;
    }

    &-content{ padding: 75px 20px 0; }

    &-title{
      margin: 10px 0 0;
      font-weight: bold;
      font-size: 24px;
    }
    &-date{ font-size: 14px; }
    &-post{ margin: 10px 0; }
  }

  &__slides{
    @include abs(50%, 50%, auto, auto);
    transform: translate(-50%, -50%);
    z-index: 8;

    &-image{
      max-height: 90vh;
      max-width: 90vw;
    }

    &-prev{
      @include abs(0, 0, 100%, 50%);
      @include transparentButton;
    }
    &-next{
      @include abs(0, 50%, 100%, 50%);
      @include transparentButton;
    }

    &-arrow{
      position: fixed;
      z-index: 9;
      &-prev{
        @include slideNavB('prev', 56px);
        left: 10px;
      }
      &-next{
        @include slideNavB('next', 56px);
        right: 10px;
      }
    }

    &-contact-info{
      @include abs(50%, 50%, 798px, 510px);
      border-top-right-radius: 25px;
      z-index: 9;
      &-email{ @include abs(420px, 30px, 75px, 445px); }
      &-phone{ @include abs(595px, 130px, 70px, 245px); }
    }

    &-animation-reel{
      @include abs(50%, 50%, 1000px, 757px);
      border-radius: 120px;
      z-index: 9;
      &-video{
        @include abs(35px, 33px, 387px, 686px);
        iframe { height: 100%; width: 100%; }
      }
    }

    .modal--mobile &{
      top: 0;
      &-animation-reel-video{ top: 260px; }
    }

    &-close{
      @include abs(-20px, calc(100% - 15px), 40px, 40px);
      font-size: 20px;
      line-height: 0;
      border-radius: 50%;
      border: solid #000 2px;
      cursor: pointer;

      &:focus, &:hover{ background: #FFF; }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue